import ReservationHotelSummary from '@/components/booking/HotelSummary'
import { API } from '@/modules/api'

export function init () {
  // On MOB & TAB we need to render sidebar component in HotelSummary to not break the layout.
  const root = document.querySelector('.booking_hotel')

  if (root) {
    const { header, hotel } = new API().getBookingHotelSummaryStaticData(root.id)

    new ReservationHotelSummary({ el: root, propsData: { header, hotel } })
  }
}


// WEBPACK FOOTER //
// ./src/modules/bookingHotelSummary.js